// API DTO types for Service Tokens

// Request to create a service token
export type ServiceTokenCreateRequest = {
  description: string;
  expiredAt?: string; // ISO 8601
};

// Response when creating a token (includes full token - only shown once!)
export type ServiceTokenCreateResponse = {
  id: number;
  token: string; // Full token - only available here!
  description: string;
  expiredAt: string | null;
  createdAt: string;
  isActive: boolean;
};

// Item in the tokens list (token is prefixed for security)
export type ServiceTokenListItem = {
  id: number;
  tokenPrefix: string; // First 8 characters only
  description: string;
  expiredAt: string | null;
  createdAt: string;
  isActive: boolean;
};

// Response for listing tokens
export type ServiceTokenListResponse = {
  tokens: ServiceTokenListItem[];
};

// Token status for UI display
export type TokenStatus = 'active' | 'expired' | 'revoked';

// Helper function to determine token status
export function getTokenStatus(token: ServiceTokenListItem): TokenStatus {
  if (!token.isActive) return 'revoked';
  if (token.expiredAt && new Date(token.expiredAt) <= new Date()) return 'expired';
  return 'active';
}
